(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .directive('attachmentListing', attachmentListing);

  /* ngInject */
  function attachmentListing(config, sessionService) {
    let directive = {
      restrict: 'E',
      templateUrl: '/templates/compliance_services/components/attachment-listing.directive.html',
      link: link,
      scope: {
        attachments: '=',
        content: '=',
        contentType: '@'
      }
    };

    return directive;

    function link(scope, _element, _attrs) {
      scope.config = config;
      scope.sessionService = sessionService;
    }
  }
})();
